import React from "react";
import ReactPaginate from "react-paginate";
import Icon from "../Icon/Icon";
import styles from "./Pagination.module.css";
import { CacheHookArgs } from "../../../lib/cache/hooks/useCache";
import { setCache } from "../../../lib/cache/cache";

interface PaginationProps {
    itemsPerPage: number;
    itemCount: number;

    onPageChange: (pageNumber: number) => void;
    cacheKey?: CacheHookArgs["cacheKey"];
    currentPage?: number;
}

const Pagination = ({ itemsPerPage, itemCount, onPageChange, cacheKey, currentPage }: PaginationProps) => {
    const pageCount = Math.ceil(itemCount / itemsPerPage);

    const handlePageClick = (event: { selected: number }) => {
        onPageChange(event.selected);
        setCache(cacheKey, event.selected);
    };

    return (
        <ReactPaginate
            className={`flex flex-wrap gap-1 items-center justify-center type-small-caps ${styles.pagination}`}
            pageClassName={`${styles.pageItem}`}
            // This has .active-page because we need a nested conditional selector for mobile
            activeClassName={`${styles.activePage} active-page`}
            activeLinkClassName={`${styles.activePage}`}
            breakLinkClassName={`${styles.pageItem}`}
            nextClassName={`${styles.pageItem}`}
            previousClassName={`${styles.pageItem}`}
            breakLabel="..."
            nextLabel={<Icon icon="arrow_right" />}
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel={<Icon icon="arrow_left" />}
            renderOnZeroPageCount={undefined}
            forcePage={currentPage}
        />
    );
};

export default Pagination;
